/** Stable id shared with VaulDrawer titleId to avoid phantom "Bottom sheet" focus stops. */
export const KNOW_WHY_REASONS_HEADING_ID = 'know-why-reasons-heading'
